import { createSelector } from 'reselect';
import { PapiGallection } from '@wix/da-papi-types';
import { getHasMoreInDirection, getItems } from '@wix/da-shared-react/pkg/Stream/base/selectors';
import { AppState } from '../types/store';

export function createFolderSelectors(deviationsStreamId: string, subfoldersStreamId: string) {
  const getFolderDeviations = (state: AppState) => getItems(state, deviationsStreamId);

  const getHasDeviations = createSelector(
    [getFolderDeviations],
    deviations => deviations.length > 0
  );

  const getSubfolders = (state: AppState) => getItems<PapiGallection>(state, subfoldersStreamId);

  const getVisibleSubfolders = (state: AppState) =>
    (getSubfolders(state) || []).filter(f => !f.isHidden);

  const getHasSubfolders = createSelector([getSubfolders], subfolders =>
    (subfolders ?? []).some(f => !f.isHidden)
  );

  const getHasMoreSubfolders = (state: AppState) =>
    getHasMoreInDirection(state, subfoldersStreamId, 'next');

  return {
    getFolderDeviations,
    getHasDeviations,
    getSubfolders,
    getVisibleSubfolders,
    getHasSubfolders,
    getHasMoreSubfolders,
  };
}
